import { LitElement, html, css, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Router } from '@lit-labs/router';
import styles from './styles.js';
import './selector-element.js';
import './unicorn-element.js';

/**
 * An example element.
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('app-root')
export class AppRoot extends LitElement {
    #router = new Router(this, [
        { path: '/', render: () => html`<selector-element></selector-element>`, enter: this.#enterHook.bind(this) },
        { path: '/login', render: () => html`Content for /login`, enter: this.#enterHook.bind(this) },
        { path: '/🕳', render: () => html`🕳`, enter: this.#enterHook.bind(this) },
        { path: '/🦄', render: () => html`<unicorn-element class="h-full pt-5 mx-5"></unicorn-element>`, enter: this.#enterHook.bind(this) },
        { path: '/🚁', render: () => html`🚁`, enter: this.#enterHook.bind(this) },
        { path: '/🏝', render: () => html`🏝`, enter: this.#enterHook.bind(this) },
    ]);
    /**
     * Copy for the read the docs hint.
     */
    @property()
    docsHint = 'Click on the Vite and Lit logos to learn more';

    static styles = [
        unsafeCSS(styles),
        css``,
    ];

    /**
     *
     */
    async #enterHook() : Promise<boolean> { return true; }

    /**
     *
     */
    render() {
        return html`
            <div class="flex flex-col h-dvh w-screen resize">
                <header class="h-1/10">
                    <nav class="navbar h-full bg-base-100 shadow-sm">
                        <div class="flex-1">
                            <a class="btn btn-ghost text-base-content text-xl">OZG Demo-Antrag</a>
                        </div>
                        <div class="flex-none">
                            <button class="btn btn-square btn-ghost">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="inline-block h-5 w-5 stroke-current"> <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"></path> </svg>
                            </button>
                        </div>
                    </nav>
                </header>
                <main class="flex h-7/10 items-center justify-center bg-base-200 overflow-y-scroll">
                    ${this.#router.outlet()}
                </main>
                <footer class="h-2/10 footer sm:footer-horizontal bg-base-100 text-base-content p-10">
                    <aside>
                        <svg
                                width="50"
                                height="50"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                class="fill-current">
                            <path
                                    d="M22.672 15.226l-2.432.811.841 2.515c.33 1.019-.209 2.127-1.23 2.456-1.15.325-2.148-.321-2.463-1.226l-.84-2.518-5.013 1.677.84 2.517c.391 1.203-.434 2.542-1.831 2.542-.88 0-1.601-.564-1.86-1.314l-.842-2.516-2.431.809c-1.135.328-2.145-.317-2.463-1.229-.329-1.018.211-2.127 1.231-2.456l2.432-.809-1.621-4.823-2.432.808c-1.355.384-2.558-.59-2.558-1.839 0-.817.509-1.582 1.327-1.846l2.433-.809-.842-2.515c-.33-1.02.211-2.129 1.232-2.458 1.02-.329 2.13.209 2.461 1.229l.842 2.515 5.011-1.677-.839-2.517c-.403-1.238.484-2.553 1.843-2.553.819 0 1.585.509 1.85 1.326l.841 2.517 2.431-.81c1.02-.33 2.131.211 2.461 1.229.332 1.018-.21 2.126-1.23 2.456l-2.433.809 1.622 4.823 2.433-.809c1.242-.401 2.557.484 2.557 1.838 0 .819-.51 1.583-1.328 1.847m-8.992-6.428l-5.01 1.675 1.619 4.828 5.011-1.674-1.62-4.829z"></path>
                        </svg>
                        <p class="text-base-content">
                            ACME Industries Ltd.
                            <br />
                            Providing reliable tech since 1992
                        </p>
                    </aside>
                    <nav>
                        <h6 class="footer-title">Services</h6>
                        <a class="link link-hover">Branding</a>
                        <a class="link link-hover">Design</a>
                        <a class="link link-hover">Marketing</a>
                        <a class="link link-hover">Advertisement</a>
                    </nav>
                    <nav>
                        <h6 class="footer-title">Company</h6>
                        <a class="link link-hover">About us</a>
                        <a class="link link-hover">Contact</a>
                        <a class="link link-hover">Jobs</a>
                        <a class="link link-hover">Press kit</a>
                    </nav>
                    <nav>
                        <h6 class="footer-title">Legal</h6>
                        <a class="link link-hover">Terms of use</a>
                        <a class="link link-hover">Privacy policy</a>
                        <a class="link link-hover">Cookie policy</a>
                    </nav>
                </footer>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'app-root' : AppRoot;
    }
}
